module.exports = __webpack_public_path__ + "img/loading2.9a24f06.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/loading2.gif
// module id = 1zSw
// module chunks = 12 17